var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.963 11.2861C12.963 10.89 12.6295 10.5565 12.2335 10.5565C11.8374 10.5565 11.5039 10.89 11.5039 11.2861C11.5039 11.5571 11.6498 11.7863 11.8374 11.9114L11.629 13.4539H12.8171L12.6086 11.9114C12.8171 11.7863 12.963 11.5571 12.963 11.2861Z",
    fill: "#565555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2313 6.36686C11.3975 6.36686 10.7305 7.05471 10.7305 7.86763V9.09744H13.7529V7.86763C13.732 7.05471 13.065 6.36686 12.2313 6.36686Z",
    fill: "#565555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7791 4.2199L13.2548 2.15633C12.5878 1.94789 11.8583 1.94789 11.1912 2.15633L4.66702 4.2199C4.27098 4.34496 4 4.72016 4 5.13705V7.59666C4 13.2246 6.75143 18.4982 11.358 21.729C11.6081 21.9166 11.9208 22 12.2126 22C12.5044 22 12.8171 21.9166 13.0672 21.729C15.3809 20.124 17.2152 17.9979 18.4867 15.5591C19.7582 13.1412 20.4461 10.4106 20.4461 7.59666V5.13705C20.4669 4.72016 20.1751 4.34496 19.7791 4.2199ZM15.7561 14.8296H8.68994V9.09744H9.64877V7.86763C9.64877 6.45023 10.7952 5.28296 12.2335 5.28296C13.6717 5.28296 14.8181 6.42938 14.8181 7.86763V9.09744H15.777V14.8296H15.7561Z",
    fill: "#565555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.342c918362f2c7d1f2ae9ce6586fd3bf.svg";
export { ForwardRef as ReactComponent };